module.exports = __webpack_public_path__ + "static/media/landingPage.c77861aa.webm";